<template>
  <vx-card class="overflow-hidden mb-2" v-on="$listeners">
    <template slot="no-body">

      <checkout-header-product :cart-product="cartProduct" />

      <div class="w-full flex flex-col mt-1">
        <div class="w-full flex flex-row">
          <div class="w-1/2 flex justify-center text-primary font-bold">
            <div class="w-full md:w-1/2 flex justify-center border-b border-primary">
              {{ $t('lists.productKind.planning') | uppercase }}
            </div>
          </div>

          <div class="w-1/2 flex justify-center text-primary font-bold">
            <div class="w-full md:w-1/2 flex justify-center border-b border-primary">
              {{ $t('lists.productKind.manufacture') | uppercase }}
            </div>
          </div>
        </div>

        <checkout-grid-product v-for="p_checkout in checkoutedProducts" :product-checkout="p_checkout" :key="p_checkout.id()" class="px-1"/>
      </div>
    </template>
  </vx-card>
</template>

<script>
import CheckoutGridProduct from "./CheckoutGridProduct";
import {Product} from "@/models/Product.model";
import CheckoutHeaderProduct from "@/views/ecommerce/components/CheckoutHeaderProduct";

export default {
  name: "CheckoutListProduct",
  components: {
    CheckoutHeaderProduct,
    CheckoutGridProduct
  },
  props: {
    cartProduct: {
      type: Product,
      required: true
    }
  },
  data() {
    return {

    }
  },
  computed: {
    checkoutedProducts() {
      return this.cartProduct.innerCheckoutProducts;
    },
  },
  methods: {

  },
  mounted() {

  }
}
</script>

<style scoped>

</style>
